/**
 * Flint Fires - Inspiration Video Gallery
 * Intersection Observer for autoplay - matches flint-product-video-features pattern
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle all video wrappers
  const videoWrappers = document.querySelectorAll('.flint-inspiration__video-wrapper');
  
  videoWrappers.forEach(videoWrapper => {
    const video = videoWrapper.querySelector('.flint-inspiration__video');
    
    if (!video) return;
    
    // Add error handling for video loading
    video.addEventListener('error', function(e) {
      console.error('🎥 Video loading error:', e);
      console.error('Video source:', video.querySelector('source')?.src);
      videoWrapper.classList.add('has-error');
    });
    
    video.addEventListener('loadeddata', function() {
      console.log('🎥 Video loaded successfully');
    });
    
    // Force video to load
    video.load();
    
    // Get play button elements
    const playToggle = videoWrapper.querySelector('.flint-inspiration__play-btn');
    const playIcon = videoWrapper.querySelector('.flint-inspiration__play-icon');
    const pauseIcon = videoWrapper.querySelector('.flint-inspiration__pause-icon');
    
    // Check if this is an autoplay video
    const isAutoplay = videoWrapper.getAttribute('data-video-autoplay') === 'true';

    // Update button icons
    function updatePlayButton(showPlay) {
      if (playIcon && pauseIcon) {
        if (showPlay) {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        }
      }
    }

    // Play/Pause toggle button - works for ALL videos
    if (playToggle) {
      playToggle.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          updatePlayButton(false);
        } else {
          video.pause();
          updatePlayButton(true);
        }
      });
    }

    // Update button on video play/pause events
    video.addEventListener('play', function() {
      updatePlayButton(false);
      videoWrapper.classList.add('is-playing');
    });

    video.addEventListener('pause', function() {
      updatePlayButton(true);
      videoWrapper.classList.remove('is-playing');
    });

    // Only setup Intersection Observer for autoplay videos
    if (isAutoplay) {
      const observerOptions = {
        threshold: 0.5, // Play when 50% visible
        rootMargin: '0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play().catch(err => {
              console.log('Autoplay prevented:', err);
            });
            updatePlayButton(false); // Show pause icon
          } else {
            video.pause();
            updatePlayButton(true); // Show play icon
          }
        });
      }, observerOptions);

      observer.observe(videoWrapper);
    }
  }); // Close forEach
});
